
import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="music-note-loader">
      <div className="note">&#9835;</div>
      <div className="note">&#9833;</div>
      <div className="note">&#9835;</div>
      <div className="note">&#9833;</div>
    </div>
  );
};

export default Loader;
